import { createCoreMethod } from '../../utils/createCoreMethod';

export const selectNode = createCoreMethod(
  'selectNode',
  async (nodeId: string) => {
    figma.currentPage.selection = [{ id: nodeId } as SceneNode];
    figma.viewport.scrollAndZoomIntoView([{ id: nodeId } as SceneNode]);

    return true;
  }
);
